import { find, isArray, get, first, map, intersection, isEqual, isEmpty, cloneDeep, toString } from "lodash";
import React from "react";
import PropTypes from "prop-types";
import SelectWithVirtualScroll from "@/components/SelectWithVirtualScroll";
import { Parameter } from "@/services/parameters";

export default class QueryBasedParameterInput extends React.Component {
  static propTypes = {
    parameter: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    mode: PropTypes.oneOf(["default", "multiple"]),
    queryId: PropTypes.number,
    onSelect: PropTypes.func,
    className: PropTypes.string,
    parameters: PropTypes.arrayOf(PropTypes.instanceOf(Parameter)),
  };

  static defaultProps = {
    value: null,
    mode: "default",
    parameter: null,
    queryId: null,
    onSelect: () => { },
    className: "",
    parameters: []
  };

  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: null,
      loading: false,
      parameters: cloneDeep(props.parameters)
    };
  }

  componentDidMount() {
    const stateRelevanceQuery = this.props.parameters.find(o => o.name === this.props.parameter.relevance_query) || {};
    this._loadOptions(this.props.queryId, stateRelevanceQuery.value);
  }


  componentDidUpdate(prevProps) {
    const { parameter } = prevProps;
    const { relevance_query, filter_symbol } = parameter;

    if (!isEmpty(relevance_query) && !isEmpty(filter_symbol)) {
      this.findRelevanceQuery(prevProps)
    }

    if (this.props.queryId !== prevProps.queryId) {
      const stateRelevanceQuery = this.state.parameters.find(o => o.name === prevProps.parameter.relevance_query) || {};
      const prevRelevanceQuery = prevProps.parameters.find(o => o.name === prevProps.parameter.relevance_query) || {};
      this._loadOptions(this.props.queryId, prevRelevanceQuery.pendingValue || stateRelevanceQuery.value);
    }
    if (this.props.value !== prevProps.value) {
      this.setValue(this.props.value);
    }
  }

  findRelevanceQuery(prevProps) {
    const prevRelevanceQuery = prevProps.parameters.find(o => o.name === prevProps.parameter.relevance_query) || {};
    const stateRelevanceQuery = this.state.parameters.find(o => o.name === prevProps.parameter.relevance_query) || {};
    if (isEmpty(prevRelevanceQuery.pendingValue) && isEmpty(stateRelevanceQuery.pendingValue)) return;
    if (toString(prevRelevanceQuery.pendingValue) !== toString(stateRelevanceQuery.pendingValue)) {
      this._loadOptions(this.props.queryId, prevRelevanceQuery.pendingValue || prevRelevanceQuery.value);
      this.setState({ parameters: cloneDeep(prevProps.parameters) })
    }
  }



  setValue(value) {
    const { options } = this.state;
    if (this.props.mode === "multiple") {
      value = isArray(value) ? value : [value];
      const optionValues = map(options, option => option.value);
      const validValues = intersection(value, optionValues);
      this.setState({ value: validValues });
      return validValues;
    }
    const found = find(options, option => option.value === this.props.value) !== undefined;
    value = found ? value : get(first(options), "value");
    this.setState({ value });
    return value;
  }

  async _loadOptions(queryId, filter_word) {
    if (queryId && queryId !== this.state.queryId) {
      this.setState({ loading: true });
      const options = await this.props.parameter.loadDropdownValues(filter_word);

      // stale queryId check
      if (this.props.queryId === queryId) {
        this.setState({ options, loading: false }, () => {
          const updatedValue = this.setValue(this.props.value);
          if (!isEqual(updatedValue, this.props.value)) {
            this.props.onSelect(updatedValue);
          }
        });
      }
    }
  }

  render() {
    const { className, mode, onSelect, queryId, value, ...otherProps } = this.props;
    const { loading, options } = this.state;
    return (
      <span>
        <SelectWithVirtualScroll
          className={className}
          disabled={loading}
          loading={loading}
          mode={mode}
          value={this.state.value}
          onChange={onSelect}
          options={map(options, ({ value, name }) => ({ label: String(name), value }))}
          showSearch
          showArrow
          notFoundContent={isEmpty(options) ? "No options available" : null}
          {...otherProps}
        />
      </span>
    );
  }
}
